import React from "react";
import { connect } from "react-redux";
import { Box, Grid, LinearProgress, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import StatBoxSlim from "components/Stats/StatBoxSlim";

const useStyles = makeStyles(() => ({
  progressLabel: {
    marginTop: 32,
    flexGrow: 1,
    textAlign: "right",
    fontSize: 13,
  },
  progressTooltip: {
    position: "absolute",
    top: 8,
    left: "50%",
    transform: "translateX(-50%)",
    whiteSpace: "nowrap",
  },
  summaryItem: {
    "@media (min-width: 1280px)": {
      flexBasis: "16.666667%",
      maxWidth: "16.666667%",
    },
  },
}));

const PhotoShootCommon = ({ homeDataPhotoShoot, selectedSeason }) => {
  const classes = useStyles();
  const progress = homeDataPhotoShoot.progressDenchu;
  const taken = Number(homeDataPhotoShoot.countReviewOk) || 0;
  const max = Number(progress?.max) || 0;
  const percentage = max > 0 ? (taken / max) * 100 : 0;

  return (
  <Grid container spacing={1}>
    <Grid item xs={12} lg={10}>
      <Grid container spacing={1}>
    <Grid item xs={12} sm={6} md={3} lg={2} className={classes.summaryItem}>
      <StatBoxSlim
        title="総写真数"
        value={homeDataPhotoShoot.countPic !== undefined ? homeDataPhotoShoot.countPic : "-"}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3} lg={2} className={classes.summaryItem}>
      <StatBoxSlim
        title="画像あり報告"
        value={homeDataPhotoShoot.countReportWithPhoto !== undefined ? homeDataPhotoShoot.countReportWithPhoto : "-"}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3} lg={2} className={classes.summaryItem}>
      <StatBoxSlim
        title="画像なし報告"
        value={homeDataPhotoShoot.countReportWithoutPhoto !== undefined ? homeDataPhotoShoot.countReportWithoutPhoto : "-"}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3} lg={2} className={classes.summaryItem}>
      <StatBoxSlim
        title="レビューOK基数"
        tip="レビューOKのユニーク基数"
        value={homeDataPhotoShoot.countReviewOk !== undefined ? homeDataPhotoShoot.countReviewOk : "-"}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3} lg={2} className={classes.summaryItem}>
      <StatBoxSlim
        title="アセット数"
        value={homeDataPhotoShoot.countDenchu !== undefined ? homeDataPhotoShoot.countDenchu : "-"}
        tip="ユニークのアセット数"
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3} lg={2} className={classes.summaryItem}>
      <StatBoxSlim
        title="撮影者数"
        value={homeDataPhotoShoot.countUniqueUser !== undefined ? homeDataPhotoShoot.countUniqueUser : "-"}
        lastItem={true}
        tip="レビュー承認（APPROVED）済みの撮影のみを対象にしたユニーク撮影者数です。"
      />
    </Grid>
      </Grid>
    </Grid>
    <Grid item xs={12} lg={2}>
      {progress && selectedSeason.length > 0 && max > 0 && (
        <>
          <Typography variant="body2">
            {`${selectedSeason[0].seasonStart.split(" ")[0]} ~ ${selectedSeason[0].seasonEnd.split(" ")[0]} アセット撮影達成率`}
          </Typography>
          <div className={classes.progressLabel}>
            <Box width="100%" position="relative">
              <Box className={classes.progressTooltip}>
                {`${taken} (${percentage.toFixed(2)}%)`}
              </Box>
              <LinearProgress variant="determinate" value={Math.min(percentage, 100)} />
              <Box display="flex" justifyContent="space-between" mt={1}>
                <Typography variant="body2" color="textSecondary">0</Typography>
                <Typography variant="body2" color="textSecondary">{max}</Typography>
              </Box>
            </Box>
          </div>
        </>
      )}
    </Grid>
  </Grid>
  );
};

const mapStateToProps = (state) => ({
  homeDataPhotoShoot: state.pictreeCommon.homeDataPhotoShoot,
  selectedSeason: state.pictreeCommon.selectedSeason,
});

export default connect(mapStateToProps)(PhotoShootCommon);
